// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1tcw_","label":"Category_label__1UvKu","content":"Category_content__3DaKJ","header":"Category_header__3xD1z","location":"Category_location__25K38"};